import "./Connect.module.css";
import Navigation from "@/reusable_sections/Header";
import Inquiry from "./sections/Inquiry";
import Reach from "./sections/Reach";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Navigation />
      <Inquiry />
      <Reach />
      <Footer />
    </div>;
}